<template>
  <div>
    <b-modal
      v-model="isError"
      :active="isError"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isError = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image"/></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section class="container section page-header section is-main-section">
                <error-page></error-page>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="isSuccess"
      :active="isSuccess"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isSuccess = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image"/></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section class="container section page-header section is-main-section">
                <thank-you :OfflineCaptureRespos="OfflineCaptureRespos" :title="title"
                noOfPage="2" :isPrint="isPrint"></thank-you>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <v-container v-if="studentInfo">
      <div v-if="studentInfo">
        <v-row key="1">
          <v-col cols="12" md="2" sm="4" align="center">
            <v-img :src="tots_image" width="120"> </v-img>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2  mb-1">
              Enquiry Code
            </div>
            <div class="text-button mb-1 " v-text="studentInfo && studentInfo.enquiryCode ? studentInfo.enquiryCode : '-'"></div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Student Name
            </div>
            <span class="text-button mb-1" v-text="studentInfo && studentInfo.studentFirstName ? studentInfo.studentFirstName + ' ' : ' '"> </span>
            <span class="text-button mb-1" v-text="studentInfo && studentInfo.studentLastName ? studentInfo.studentLastName : ' '"> </span>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Franchisee Name
            </div>
            <div class="text-button mb-1" v-text="studentInfo && studentInfo.franchisee.companyName ? studentInfo.franchisee.companyName : '-'"></div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Academic Year
            </div>
            <div class="text-button mb-1" v-text="studentInfo && studentInfo.academicYear.academicYear ? studentInfo.academicYear.academicYear : '-'"></div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Class
            </div>
            <div class="text-button mb-1" v-text="studentInfo && studentInfo.class ? studentInfo.class : '-'"></div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Parent / Guardian Name
            </div>
            <div class="text-button mb-1" v-text="studentInfo && studentInfo.fatherName ? studentInfo.fatherName : '-'"></div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Parent / Guardian Mobile
            </div>
            <div class="text-button mb-1" v-text="studentInfo && studentInfo.fatherMobile ? studentInfo.fatherMobile : '-'"></div>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Parent / Guardian Email
            </div>
            <div class="text-button mb-1" v-text="studentInfo && studentInfo.fatherEmailID ? studentInfo.fatherEmailID : '-'"></div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Student Gender
            </div>
            <div v-if="studentInfo.gender ==='Female' || studentInfo.gender ==='FEMALE'" class="text-button mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Female' ? 'Girl' : '-'||studentInfo && studentInfo.gender && studentInfo.gender ==='FEMALE' ? 'Girl' : '-'"></div>
                <div v-if="studentInfo.gender ==='Male' || studentInfo.gender ==='MALE'" class="text-button mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Male' ? 'Boy' : '-' || studentInfo && studentInfo.gender && studentInfo.gender ==='MALE' ? 'Boy' : '-'"></div>
                <div v-if="studentInfo.gender === null" class="mb-1">-</div>
                 <div v-if="studentInfo.gender === ''" class="mb-1">-</div>
          </v-col>
          <v-col cols="12" md="2" sm="4">
            <div class="grey--text text-subtitle-2 mb-1">
              Section / Division
            </div>
            <div class="text-button mb-1" v-text="studentInfo && studentInfo.section ? studentInfo.section : '-'"></div>
          </v-col>
        </v-row>

        <v-row key="3">
          <v-col cols="12">
            <template>
              <v-row>
                <v-col cols="12" lg="12" sm="12">
                  <v-data-table :headers="headers" :items="feeTypeGroup" :single-expand="true" show-expand hide-default-footer class="elevation-1" item-key="feeTypeName">
                    <!-- <template v-slot:top>
                      <v-toolbar flat color="warning lighten-3" class="d-flex justify-center">
                        <v-toolbar-title>Fee Structure (In Installments)</v-toolbar-title>
                      </v-toolbar>
                    </template> -->
                    <template v-slot:item.position="{ item }">
                      <v-text-field v-model="item.position" readonly class="centered-input">
                        <v-icon slot="append" color="green" @click="changeInstallments('plus', item)">
                          mdi-plus
                        </v-icon>
                        <v-icon slot="prepend" color="red" @click="changeInstallments('minus', item)">
                          mdi-minus
                        </v-icon>
                      </v-text-field>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pb-4 pt-4">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center">Pay Now</th>
                                <th class="text-center">
                                  Installment Name
                                </th>
                                <th class="text-center">
                                  Amount
                                </th>
                                <th class="text-center" v-if="isConcession">
                                  Concession Amount
                                </th>
                                <th class="text-center">
                                  Amount Due
                                </th>

                                <th class="text-center" v-if="isGST && !isIGST">
                                  CGST Amount
                                </th>

                                <th class="text-center" v-if="isGST && !isIGST">
                                  SGST Amount
                                </th>

                                <th class="text-center" v-if="isGST && isIGST">
                                  IGST Amount
                                </th>

                                <th class="text-center">
                                  Amount To Pay
                                </th>
                                <th class="text-center">
                                  Due Date
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="element in item.installments" :key="element.id">
                                <td align="center">
                                  <v-checkbox class="shrink mr-0 mt-0" readonly :value="true" v-model="element.isChecked" :disabled="element.isCompulsory" hide-details></v-checkbox>
                                </td>
                                <td align="center" justify="center">{{ element.name }}</td>
                                <td align="center" justify="center">{{ Number(element.amount).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isConcession">{{ Number(element.amountConcession).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.amountDue).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isGST && !isIGST">{{ Number(element.cGSTAmt).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isGST && !isIGST">{{ Number(element.sGSTAmt).toFixed(2) }}</td>
                                <td align="center" justify="center" v-if="isGST && isIGST">{{ Number(element.iGSTAmt).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ Number(element.payableAmt).toFixed(2) }}</td>
                                <td align="center" justify="center">{{ new Date(element.dueDate).toLocaleDateString() }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </td>
                    </template>
                    <template v-slot:body.append="{ headers }">
                      <tr :class="{ 'v-data-table__mobile-table-row': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }">
                        <td :class="{ 'v-data-table__mobile-row': $vuetify.breakpoint.xs, 'text-center': $vuetify.breakpoint.smAndUp }" v-for="(header, i) in headers" :key="i">
                          <div :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }" v-if="header.value == 'position'" class=" text-subtitle-2">
                            Totals
                          </div>
                          <div :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }" v-if="header.value == 'totalAmount'" class=" text-subtitle-2">
                            <span class="mdi mdi-currency-inr"></span>{{ totalAmount.toFixed(2) }}
                          </div>
                          <div
                            :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                            class=" text-subtitle-2"
                            v-if="isConcession && header.value == 'totalConcession'"
                          >
                            <span class="mdi mdi-currency-inr"></span>{{ totalConcession.toFixed(2) }}
                          </div>
                          <div :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }" v-if="header.value == 'totalAmountDue'" class=" text-subtitle-2">
                            <span class="mdi mdi-currency-inr"></span>{{ totalAmountDue.toFixed(2) }}
                          </div>
                          <div
                            :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                            class=" text-subtitle-2"
                            v-if="isGST && isIGST && header.value == 'totalIGST'"
                          >
                            <span class="mdi mdi-currency-inr"></span>{{ totalIGST.toFixed(2) }}
                          </div>
                          <div
                            :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                            class=" text-subtitle-2"
                            v-if="isGST && !isIGST && header.value == 'totalCGST'"
                          >
                            <span class="mdi mdi-currency-inr"></span>{{ totalCGST.toFixed(2) }}
                          </div>
                          <div
                            :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                            class=" text-subtitle-2"
                            v-if="isGST && !isIGST && header.value == 'totalSGST'"
                          >
                            <span class="mdi mdi-currency-inr"></span>{{ totalSGST.toFixed(2) }}
                          </div>
                          <div
                            :class="{ 'v-data-table__mobile-row__cell': $vuetify.breakpoint.xs, ' ': $vuetify.breakpoint.smAndUp }"
                            v-if="header.value == 'totalAmountPayable'"
                            class=" text-subtitle-2"
                          >
                            <span class="mdi mdi-currency-inr"></span>{{ Number(totalAmountToPay).toFixed(2) }}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container>
      <v-card outlined class="pa-3">
        <form>
          <v-row>
            <!-- <v-col cols="12" md="4">
              <v-autocomplete placeholder="--Select--" class="my-0 py-1" :items="admissionType" :item-text="text" :item-value="value"> </v-autocomplete>
            </v-col> -->
            <v-col cols="12">
              <v-card-title class="ma-0 pa-0 mb-4">Payment Mode</v-card-title>
              <v-tabs v-model="model" left slider-color="#000">
                <v-tab>Cash</v-tab>
                <v-tab>Cheque</v-tab>
                <v-tab>Credit/Debit card swipe</v-tab>
                <v-tab>Internet Payment</v-tab>
                <v-tab>Demand Draft</v-tab>
              </v-tabs>
              <v-divider class="my-0"></v-divider>
              <v-tabs-items v-model="model">
                <v-tab-item>
                  <v-card flat>
                    <!-- <v-card-text>
                      hi
                    </v-card-text> -->
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-card-title>
                        Enter Cheque Details
                        <v-icon color="primary" right>mdi-information</v-icon>
                      </v-card-title>
                      <v-divider class="my-0"></v-divider>
                    </v-card-text>
                    <v-container>
                      <form>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="12">
                                <label class="font-weight-medium body-2">Cheque No. <span class="error--text">*</span></label>
                                <v-text-field single-line placeholder="Cheque No." class="my-0 py-1" v-model="cheque.chequeNO"></v-text-field>
                              </v-col>

                              <v-col cols="12" v-if="cheque.paymentType && cheque.paymentType !== 'IFSC_CODE'">
                                <label class="font-weight-medium body-2">MICR Code <span class="error--text"></span></label>
                                <v-text-field single-line placeholder="MICR Code" v-model="cheque.MICRCode" class="my-0 py-1"></v-text-field>
                              </v-col>

                              <v-col cols="12">
                                <label class="font-weight-medium body-2">Bank Branch </label>
                                <v-text-field single-line placeholder="Bank Branch" v-model="cheque.branchName" class="my-0 py-1"></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <label class="font-weight-medium body-2">Cheque Date</label>
                                <custom-date-picker prepend-icon="mdi-calendar" v-model="cheque.chequeDate"></custom-date-picker>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-row>
                              <!-- <v-col cols="12">
                                <label class="font-weight-medium body-2">Search By</label>
                                <v-autocomplete placeholder="--Select--" class="my-0 py-1" :items="admissionType" :item-text="text" :item-value="value"> </v-autocomplete>
                              </v-col> -->
                              <v-col cols="12">
                                <label class="font-weight-medium body-2">Type</label>
                                <v-autocomplete placeholder="--Select--" class="my-0 py-1" v-model="cheque.paymentType" :items="bankIFSC" item-text="text" item-value="value" key="value">
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" v-if="cheque.paymentType && cheque.paymentType !== 'MICR_CODE'">
                                <label class="font-weight-medium body-2">IFSC Code </label>
                                <v-text-field single-line placeholder="IFSC Code" v-model="cheque.IFSCCode" class="my-0 py-1"></v-text-field>
                              </v-col>

                              <v-col cols="12">
                                <label class="font-weight-medium body-2">Bank Name <span class="error--text">*</span></label>
                                <v-text-field single-line placeholder="Bank Name" v-model="cheque.bankName" class="my-0 py-1"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </form>
                    </v-container>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-card-title>
                        Enter Credit/Debit card swipe Details
                        <!-- <v-icon color="primary" right>mdi-information</v-icon> -->
                      </v-card-title>
                      <v-divider class="my-0"></v-divider>
                    </v-card-text>
                    <v-container>
                      <form>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="12" md="7">
                                <label class="font-weight-medium body-2">Card Type <span class="error--text">*</span></label>
                                <v-autocomplete placeholder="--Select--" class="my-0 py-1" v-model="cardSwipe.transactionType" :items="cardType" item-text="text" item-value="value" key="value">
                                </v-autocomplete>
                              </v-col>
                              <!--
                              <v-col cols="12" md="5">
                                <label class="font-weight-medium body-2">Date</label>
                                <custom-date-picker prepend-icon="mdi-calendar"></custom-date-picker>
                              </v-col> -->
                              <v-col cols="12">
                                <label class="font-weight-medium body-2">Bank Name <span class="error--text">*</span></label>
                                <v-text-field single-line placeholder="Bank Name" v-model="cardSwipe.bankName" class="my-0 py-1"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="12" md="6">
                                <label class="font-weight-medium body-2">Card Last 4 digits <span class="error--text">*</span> </label>
                                <v-text-field single-line placeholder="CARD LAST DIGIT" v-model="cardSwipe.cardLastFourDigit" class="my-0 py-1"></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6">
                                <label class="font-weight-medium body-2">Approved Code <span class="error--text">*</span></label>
                                <v-text-field single-line placeholder="APPROVED CODE" v-model="cardSwipe.approvalCode" class="my-0 py-1"></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <label class="font-weight-medium body-2">Remarks </label>
                                <v-text-field single-line placeholder="Remarks" v-model="cardSwipe.remark" class="my-0 py-1"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </form>
                    </v-container>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-card-title>
                        Enter Internet Payment Details
                      </v-card-title>
                      <v-divider class="my-0"></v-divider>
                    </v-card-text>
                    <v-container>
                      <form>
                        <v-row>
                          <v-col cols="12" md="3">
                            <label class="font-weight-medium body-2">Options</label>

                            <v-autocomplete v-model="internetPayment.transactionType" placeholder="--Select--" class="my-0 py-1" :items="paymentMode" item-value="name" item-text="name">
                            </v-autocomplete>
                          </v-col>

                          <v-col cols="12" md="3">
                            <label class="font-weight-medium body-2">Bank Name </label>
                            <v-text-field single-line placeholder="Bank Name" v-model="internetPayment.bankName" class="my-0 py-1"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <label class="font-weight-medium body-2">Transaction ID <span class="error--text">*</span></label>
                            <v-text-field single-line placeholder="ID" v-model="internetPayment.transactionID" class="my-0 py-1"></v-text-field>
                          </v-col>
                        </v-row>
                      </form>
                    </v-container>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-card-title>
                        Enter Demand Draft Details
                        <v-icon color="primary" right>mdi-information</v-icon>
                      </v-card-title>
                      <v-divider class="my-0"></v-divider>
                    </v-card-text>
                    <v-container>
                      <form>
                        <v-row>
                          <v-col cols="12" md="3">
                            <label class="font-weight-medium body-2">DD No <span class="error--text">*</span></label>
                            <v-text-field single-line placeholder="DD No" v-model="DD.ddNO" class="my-0 py-1"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <label class="font-weight-medium body-2">Drawn On <span class="error--text">*</span></label>
                            <v-text-field single-line placeholder="Drawn On" v-model="DD.drawnOn" class="my-0 py-1"></v-text-field>
                          </v-col>
                        </v-row>
                      </form>
                    </v-container>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
            <!-- <v-col class="12" md="6">
              <v-card-title class="ma-0 pa-0 mb-4">Receipt Type</v-card-title>
              <v-radio-group v-model="radioGroup1" row>
                <v-radio label="Online"></v-radio>
                <v-radio label="Manual"></v-radio>
              </v-radio-group>
            </v-col> -->
            <!-- <v-col class="12" md="6">
              <label class="text-decoration-underline font-weight-medium body-2">Skip Receipt No.</label>
            </v-col> -->
            <v-col class="12" md="4">
              <v-card-title class="ma-0 pa-0 mb-4">Date of Payment</v-card-title>
              <!-- '2021-11-25' -->
              <custom-date-picker :minToDate="minDate"  prepend-icon="mdi-calendar" v-model.trim="dateOfPayment"></custom-date-picker>
            </v-col>
          </v-row>
          <v-card-actions disabled="true">
            <v-row align="center" justify="end">
              <v-col class="12" md="3">
                <v-text-field
                  label="Please Enter Amount (INR)"
                  persistent-hint
                  hint="Amount which user want to pay now in INR."
                  filled
                  dense
                  type="number"
                  v-model="partialAmount"
                  shaped
                ></v-text-field>
              </v-col>
              <v-col class="12" md="2">
                <v-btn color="primary" dark @click.prevent="Pay" x-large>
                  <v-icon left dark>
                    mdi-cash-100
                  </v-icon>
                  Pay Now
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </form>
      </v-card>

      <loading-icon :value="isLoading" />
      <dialog-alert :dialogObj="dialogObj" v-model="dialogObj.show" @clicked="dialogClicked"></dialog-alert>
    </v-container>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'

import ThankYou from '../../components/Fees/payment/thankYou'
import ErrorPage from '../../components/Fees/payment/error'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import DialogAlert from '@/components/template/DialogAlert'

export default {
  name: 'PaymentServicePlanOffline',
  components: {
    ThankYou,
    ErrorPage,
    CustomDatePicker,
    DialogAlert
  },
  props: ['referenceID', 'planID'],
  data () {
    return {
      loading: false,
      dialogAccept: false,
      payLoad1: '',
      minDate: moment().format('YYYY-MM-DD'),
      cashCardOrderID: '',
      dialogObj: {
        id: '',
        title: '',
        acceptName: '',
        rejectName: '',
        subtitle: '',
        show: false,
        params: {},
        isNo: true,
        isLoadingYes: false,
        isLoadingNo: false,
        types: {
          payment: 'PAYMENT'
        },
        isSubTHtml: false
      },
      cardType: [
        { text: 'CREDIT CARD', value: 'CREDIT_CARD' },
        { text: 'DEBIT CARD', value: 'DEBIT_CARD' }
      ],
      paymentMode: [],
      bankIFSC: [
        { text: 'MICR Code', value: 'MICR_CODE' },
        { text: 'IFSC Code', value: 'IFSC_CODE' },
        { text: 'Both(MICR/IFSC)', value: 'MICR_IFSC_CODE' }
      ],
      title: '',
      orderID: '',
      model: '',
      dialog1: false,
      isLoading: false,
      radioGroup1: 1,
      radioGroup2: 1,
      radioGroup3: 1,
      radioGroup4: 1,
      radioGroup5: 1,
      radioGroup6: 1,
      radioGroup7: 1,
      isPrint: true,
      Date: moment().format('YYYY-MM-DD'),
      OfflineCaptureRespos: [],
      isRecipt: false,
      disable: true,
      selectedRows: [],
      selecteditem: '',
      snackbar: false,
      limitCallBack: 0,
      snackbarMsg: '',
      snackbarTimeout: 2000,
      headers: this.getHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      paginated: false,
      gstType: 'IGST',
      isGST: false,
      isIGST: true,
      isConcession: false,
      loadingComponent: null,
      totalAmount: 0,
      totalAmountDue: 0,
      totalConcession: 0,
      totalAmountToPay: 0,
      partialAmount: 0,
      totalCGST: 0,
      totalSGST: 0,
      totalIGST: 0,
      checkedRows: [],
      isSuccess: false,
      isError: false,
      isSelected: '',
      feeSelected: [],
      feeTypeGroup: [],
      sumArray: [],
      breakUpData: [],
      feeTypeNaming: '',
      studentInfo: null,
      paymentType: '',
      orderidResponse: '',
      cheque: { chequeNO: '', chequeDate: '', paymentType: '', transactionType: '', MICRCode: '', cheque: '', IFSCCode: '', bankName: '', branchName: '' },
      internetPayment: { transactionType: '', bankName: '', transactionID: '' },
      cardSwipe: { transactionType: '', approvalCode: '', cardLastFourDigit: '', bankName: '', branchName: '', remark: '' },
      DD: { transactionType: '', ddNO: '', drawnOn: '' },
      dateOfPayment: moment().format('YYYY-MM-DD')
    }
  },
  async created () {
    window.addEventListener('beforeunload', this.beforePageDestroyed)
    window.addEventListener('unload', this.beforePageDestroyed)
    await this.getAllInfo()
    await this.getPaymentOption()
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforePageDestroyed)
    window.removeEventListener('unload', this.beforePageDestroyed)
  },
  watch: {
    model: function (val) {
      if (val === 0) {
        this.paymentType = 'CASH'
      }
      if (val === 1) {
        this.paymentType = 'CHEQUE'
      }
      if (val === 2) {
        this.paymentType = 'CARD_SWIPE'
      }
      if (val === 3) {
        this.paymentType = 'INTERNET_PAYMENT'
      }
      if (val === 4) {
        this.paymentType = 'DEMAND_DRAFT'
      }
      this.DD.ddNO = ''
      this.DD.drawnOn = ''
      this.internetPayment.transactionType = ''
      this.cheque.bankName = ''
      this.internetPayment.transactionID = ''
      this.cardSwipe.cardLastFourDigit = ''
      this.cardSwipe.approvalCode = ''
      this.cardSwipe.remark = ''
      this.internetPayment.bankName = ''
      this.internetPayment.transactionID = ''
      this.cheque.chequeNO = ''
      this.cheque.MICRCode = ''
      this.cheque.branchName = ''
      this.cheque.chequeDate = ''
      this.cardSwipe.bankName = ''
    }
  },
  methods: {
    getPaymentOption: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/internetpaymentoption`)
        this.paymentMode = data
        console.log(this.paymentMode)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    acceptPayment: async function () {
      try {
        if (this.payLoad1) {
          this.loading = true
          await this.orderAPI(this.payLoad1)
        }
        if (this.cashCardOrderID.data) {
          this.loading = true
          await this.captureAPI(this.cashCardOrderID.data.orderID)
        }
        this.dialogAccept = false
      } catch (e) {
        this.dialogAccept = false
      } finally {
        this.loading = false
      }
    },
    beforePageDestroyed: async function (e) {
      console.log('beforePageDestroyedPayment ONLINE')
      if (this.orderID) {
        e.returnValue = ''
        await this.reject().catch(err => {
          console.log(err)
        })
        e.preventDefault()
        e.returnValue = false // Seems require this for Chrome
      }
    },
    dialogClicked: async function (value) {
      switch (value.dialog.id) {
        case this.dialogObj.types.payment:
          if (value.isSuccess) {
            Object.assign(this.dialogObj, {
              isLoadingYes: true
            })
            await this.captureAPI(this.dialogObj.params.orderID)
          } else {
            Object.assign(this.dialogObj, {
              isLoadingNo: true
            })
            this.orderID = this.dialogObj.params.id
            await this.reject()
          }
      }
      Object.assign(this.dialogObj, {
        show: false,
        isLoadingYes: false,
        isLoadingNo: false
      })
    },
    openDialog (type, params) {
      this.orderID = params.id
      Object.assign(this.dialogObj, {
        id: type,
        params,
        show: true,
        isSubTHtml: true,
        title: 'Are you sure to complete payment?',
        subtitle: `<p>Please click "Yes" to <b>COMPLETE</b> this payment and "No" to <b>CANCEL</b> this payment.</p>` + `<p>Receipt No : <b>${params.receiptNo}</b></p>`
      })
    },
    reject: async function () {
      console.log(this.orderID)
      if (!this.orderID) {
        return
      }
      try {
        this.isLoading = true
        await http.patch(`${constants.API_URL}/api/payments/reject/order`, { orderID: this.orderID })
        this.isLoading = false
        this.dialog1 = false
        this.orderID = ''
        this.model = 0
        this.$dialog.info({
          text: `Offline Payment Rejected !!`,
          title: 'Rejected'
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Reject API --', errorMessage)
        console.log('Reject API : ', errorMessage)
        this.dialog1 = false
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    closePopUp () {
      this.isSuccess = false
      window.location.href = constants.FRONTEND
    },
    openSnackbar (msg) {
      if (!this.snackbar) {
        this.snackbarMsg = msg
        this.snackbar = true
        this.limitCallBack--
      } else {
        // Usage!
        if (this.limitCallBack < 1) {
          this.limitCallBack++
          setTimeout(this.openSnackbar(msg), this.snackbarTimeout)
        }
      }
    },
    changeInstallments: function (type, item) {
      if (type === 'plus') {
        if (item.position >= item.maxPosition) {
          item.position = item.maxPosition
          this.openSnackbar('All due installments are selected.')
        } else {
          item.position = item.position + 1
        }
      } else {
        if (item.position <= item.minPosition) {
          item.position = item.minPosition
          this.openSnackbar('Minimum due till dates installments are selected.')
        } else {
          item.position = item.position - 1
        }
      }
      this.calculatePayAmount()
    },
    getHeaders () {
      let header = [
        { text: 'Fee Type', value: 'feeTypeName', align: 'center' },
        { text: 'Installments', value: 'position', align: 'center', width: 150 },
        { text: 'Amount', value: 'totalAmount', align: 'center' }
      ]

      if (this.isConcession) {
        header.push({ text: 'Concession Amount', value: 'totalConcession', align: 'center' })
      }
      header.push({ text: 'Amount Due', value: 'totalAmountDue', align: 'center' })

      if (this.isGST) {
        if (this.isIGST) {
          header.push({ text: 'IGST', value: 'totalIGST', align: 'center' })
        } else {
          header.push({ text: 'CGST', value: 'totalCGST', align: 'center' })
          header.push({ text: 'SGST', value: 'totalSGST', align: 'center' })
        }
      }
      header.push({ text: 'Amount To Pay', value: 'totalAmountPayable', align: 'center' })
      header.push({ text: '', value: 'data-table-expand' })
      return header
    },
    calculatePayAmount () {
      this.totalAmount = 0
      this.totalAmountDue = 0
      this.totalConcession = 0
      this.totalAmountToPay = 0
      this.partialAmount = 0
      this.totalIGST = 0
      this.totalCGST = 0
      this.totalSGST = 0
      this.checkedRows = []
      _.forEach(this.feeTypeGroup, item => {
        item.totalAmount = 0
        item.totalAmountDue = 0
        item.totalConcession = 0
        item.totalAmountPayable = 0
        item.totalCGST = 0
        item.totalSGST = 0
        item.totalIGST = 0
        _.forEach(item.installments, (itemChild, indexChild) => {
          if (item.position > indexChild) {
            itemChild.isChecked = true
            item.totalAmount = this.addTwoNumber(item.totalAmount, itemChild.amount)
            item.totalAmountDue = this.addTwoNumber(item.totalAmountDue, itemChild.amountDue)
            item.totalConcession = this.addTwoNumber(item.totalConcession, itemChild.amountConcession)
            item.totalCGST = this.addTwoNumber(item.totalCGST, itemChild.cGSTAmt)
            item.totalSGST = this.addTwoNumber(item.totalSGST, itemChild.sGSTAmt)
            item.totalIGST = this.addTwoNumber(item.totalIGST, itemChild.iGSTAmt)
            item.totalAmountPayable = this.addTwoNumber(item.totalAmountPayable, itemChild.payableAmt)
            this.checkedRows.push(itemChild.id)
          } else {
            itemChild.isChecked = false
          }
        })
        this.totalAmount = this.addTwoNumber(item.totalAmount, this.totalAmount)
        this.totalAmountDue = this.addTwoNumber(item.totalAmountDue, this.totalAmountDue)
        this.totalConcession = this.addTwoNumber(item.totalConcession, this.totalConcession)
        this.totalIGST = this.addTwoNumber(item.totalIGST, this.totalIGST)
        this.totalCGST = this.addTwoNumber(item.totalCGST, this.totalCGST)
        this.totalSGST = this.addTwoNumber(item.totalSGST, this.totalSGST)
        this.totalAmountToPay = this.addTwoNumber(item.totalAmountPayable, this.totalAmountToPay)
        this.partialAmount = this.totalAmountToPay
      })
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },

    Pay: async function (event) {
      if (_.isEmpty(this.checkedRows)) {
        this.dialog1 = false
        return this.$dialog.error({
          text: ` Please select at least one installment`,
          title: 'Error'
        })
      }

      if (this.partialAmount <= 0) {
        this.dialog1 = false
        return this.$dialog.error({
          text: ` Minimum amount 1 Rupee for procced`,
          title: 'Error'
        })
      }
      if (this.partialAmount > this.totalAmountToPay) {
        return this.$dialog.error({
          text: ` Amount must be less than actual Amount to pay  `,
          title: 'Error'
        })
      }

      try {
        let payLoad = {
          assignServiceFeeComponentID: this.planID,
          referenceID: this.referenceID,
          amount: this.partialAmount,
          dateOfPayment: this.dateOfPayment,
          assignFeeInstallmentID: this.checkedRows
        }
        if (this.paymentType === 'CASH') {
          payLoad.transactionType = this.paymentType
        }
        if (this.paymentType === 'CHEQUE') {
          payLoad.chequeNO = this.cheque.chequeNO
          payLoad.chequeDate = this.cheque.chequeDate
          payLoad.transactionType = this.paymentType

          payLoad.bankName = this.cheque.bankName
          payLoad.branchName = this.cheque.branchName
          payLoad.paymentType = this.cheque.paymentType
          if (this.cheque.paymentType === 'MICR_CODE') {
            payLoad.MICRCode = this.cheque.MICRCode
          }
          if (this.cheque.paymentType === 'IFSC_CODE') {
            payLoad.IFSCCode = this.cheque.IFSCCode
          }
          if (this.cheque.paymentType === 'MICR_IFSC_CODE') {
            payLoad.MICRCode = this.cheque.MICRCode
            payLoad.IFSCCode = this.cheque.IFSCCode
          }
        }
        if (this.paymentType === 'CARD_SWIPE') {
          payLoad.transactionType = this.paymentType
          payLoad.approvalCode = this.cardSwipe.approvalCode
          payLoad.cardLastFourDigit = this.cardSwipe.cardLastFourDigit
          payLoad.bankName = this.cardSwipe.bankName

          payLoad.remark = this.cardSwipe.remark
          payLoad.paymentType = this.cardSwipe.transactionType
        }
        if (this.paymentType === 'INTERNET_PAYMENT') {
          payLoad.transactionType = this.paymentType
          payLoad.bankName = this.internetPayment.bankName
          payLoad.transactionID = this.internetPayment.transactionID
          payLoad.paymentType = this.internetPayment.transactionType
        }
        if (this.paymentType === 'DEMAND_DRAFT') {
          payLoad.transactionType = this.paymentType
          payLoad.ddNO = this.DD.ddNO
          payLoad.drawnNO = this.DD.drawnOn
        }
        this.payLoad1 = payLoad
        await this.orderAPI(this.payLoad1)
        if (this.cashCardOrderID.data) {
          this.openDialog(this.dialogObj.types.payment, this.cashCardOrderID.data)
        }
        // this.orderidResponse = orderIDRes.data
        // console.log('    this.orderidResponse ', this.orderidResponse)
        // this.isLoading = false
        // if (this.orderidResponse) {
        //   this.dialog1 = true
        // }
        // this.model = 0
        // return this.$dialog.info({
        //   text: `Offline Payment Saved Successfully`,
        //   title: 'Success'
        // })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.dialog1 = false

        console.log('While saving : ', e)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    orderAPI: async function (payLoad) {
      try {
        this.isLoading = true
        const orderIDRes = await http.post(`${constants.API_URL}/api/service/payments/offline/order`, payLoad)
        this.cashCardOrderID = orderIDRes
      } catch (e) {
        await this.reject()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        // this.isError = true
        this.dialog1 = false
        console.log('Error Triggered')
        console.log('Order API: ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    captureAPI: async function (orderID) {
      try {
        this.isLoading = true
        const captureResponse = await http.post(`${constants.API_URL}/api/service/payments/offline/capture`, { orderID })

        const invoiceRes = await http.get(`${constants.API_URL}/api/student-invoice/${captureResponse.data.paymentOrderData.id}`)

        this.OfflineCaptureRespos = invoiceRes

        if (this.OfflineCaptureRespos) {
          this.isSuccess = true
          if (
            (this.OfflineCaptureRespos.data.paymentOrderData.referenceURLType === 'ADMISSION_FORM_FIRST_TIME_OFFLINE' &&
              this.OfflineCaptureRespos.data.paymentOrderData.status === 'APPROVAL_WAITING') ||
            this.OfflineCaptureRespos.data.paymentOrderData.referenceURLType === 'APPLICATION_FORM_OFFLINE'
          ) {
            this.title = 'Note :Please approve Offline payment from Finance module and generate the fee receipt from student ledger'
            this.isPrint = false
          }
        }

        this.isLoading = false
        this.model = 0
        this.orderID = ''
        this.dialog1 = false
        // this.$dialog.info({
        //   text: `Offline Payment Saved Successfully`,
        //   title: 'Success'
        // })
      } catch (e) {
        await this.reject()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isError = true
        this.dialog1 = false
        console.log('captureAPI: ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getAllInfo: async function () {
      console.log(this.planID, this.referenceID, 'dnon')
      try {
        this.isLoading = true
        let response = await http.get(`${constants.API_URL}/api/service-fee-payment/installments/${this.referenceID}`)
        this.studentInfo = response.data.studentInfo
        console.log('Service Plan Offline', this.studentInfo)
        // this.studentInfo.class = this.studentInfo.serviceRegistration.studentClass.name
        const feeTypeData = response.data.feeTypes
        this.feeTypeGroup = feeTypeData.feeTypeGroup
        this.isConcession = feeTypeData.isConcession
        this.gstType = feeTypeData.gstType
        this.isIGST = _.isEqual(feeTypeData.gstType, 'IGST')
        this.isGST = feeTypeData.isGST
        this.calculatePayAmount()
        this.headers = this.getHeaders()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isError = true

        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="css">
.v-data-table__mobile-row {
  display: table-cell !important;
}
</style>
